module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "project-banner",
    attrs: {
      "to": {
        path: _vm.projectPath
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imagePath()
    }
  }), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.project.name))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30e49053"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectBanner.vue
// module id = 114
// module chunks = 0